import React, { useState, useEffect, useCallback } from "react";
import { useOutletContext } from "react-router-dom";
import axios from "axios";
import { notifyError } from "../components/notify";
import { API_BASE_URL, BASIC_AUTH, formatDateForDatabase } from "../constants";
import ButtonSpinner from "../components/Spinner/ButtonSpinner";
import DateInput from "../components/DatePicker";
import DeliveredOrderCard from "../components/DeliveredOrderCard";

const DeliveredOrderHistory = () => {
  const currentDate = new Date();
  const { setPageTitle } = useOutletContext();
  const [deliveredOrder, setDeliveredOrder] = useState([]);
  const [loading, setLoading] = useState(false);
  const [FromDate, setFromDate] = useState(currentDate);
  const [ToDate, setToDate] = useState(currentDate);

  useEffect(() => {
    setPageTitle("Delivered Orders History");
  }, [setPageTitle]);

  const userStr = localStorage.getItem("user");
  const user = userStr ? JSON.parse(userStr) : null;

  const companyStr = localStorage.getItem("company");
  const company = companyStr ? JSON.parse(companyStr) : null;

  const getReadyDeliveredOrders = useCallback(async () => {
    setLoading(true);
    let formattedFromDate = formatDateForDatabase(FromDate);
    let formattedToDate = formatDateForDatabase(ToDate);
    try {
      const response = await axios.get(
        `${API_BASE_URL}/delivery/get_delivered_order_history?companycode=${company.companycode}&delivery_agent_code=${user.delivery_agents_code}
        &from_date=${formattedFromDate}&to_date=${formattedToDate}`,
        {
          headers: {
            Authorization: BASIC_AUTH,
            "Content-Type": "application/json",
          },
        }
      );

      const result = response.data;

      setDeliveredOrder(result || []);
    } catch (error) {
      console.error("API Error:", error);
      notifyError(error.Message || "Failed to fetch ready delivery orders");
      setDeliveredOrder([]);
    } finally {
      setLoading(false);
    }
  }, [company?.companycode, user.delivery_agents_code, FromDate, ToDate]);

  return (
    <>
      <div className="col-12  d-lg-flex d-block px-2 pt-3 g-2 align-items-center">
        {/* From Date */}
        <div className="col-12 col-lg-5 d-lg-flex d-block d-md-flex">
          <label className="col-12 col-lg-5 col-md-6 text-sm text-theme fw-bold mt-1">
            Select From Date <span className="red-error">*</span>
          </label>
          <div className="col-12 col-lg-6 col-md-6">
            <DateInput
              selected={FromDate}
              onChange={setFromDate}
              defaultMonth={FromDate || new Date()}
            />
          </div>
        </div>

        {/* To Date */}
        <div className="col-12 col-lg-3  mt-2 mt-lg-0 d-lg-flex d-md-flex d-block">
          <label className="col-12 col-md-6 col-lg-4 text-sm text-theme fw-bold mt-1">
            To Date <span className="red-error">*</span>
          </label>
          <div className="col-12 col-md-6 col-lg-8">
            <DateInput
              selected={ToDate}
              onChange={setToDate}
              defaultMonth={ToDate || new Date()}
            />
          </div>
        </div>

        {/* Proceed Button */}
        <div className="col-11 col-md-6 col-lg-3 d-flex align-items-center justify-content-lg-center justify-content-start mt-2 mt-lg-0">
          <ButtonSpinner
            type="submit"
            className="col-md-7 col-lg-9 col-7  btn-theme btn-md text-black"
            loading={loading}
            onClick={getReadyDeliveredOrders}
          >
            <b>{loading ? "Proceeding..." : "Proceed"}</b>
          </ButtonSpinner>
        </div>
      </div>

      {!loading && (
        <>
          <hr className="text-white" />
          <div className="container-fluid">
            <div className="row">
              {/*  Pending Orders Section */}
              {deliveredOrder.length > 0 && (
                <>
                  {deliveredOrder.map((order) => (
                    <DeliveredOrderCard
                      key={order.ordercode}
                      order={order}
                      buttonLable="Accept Order"
                    />
                  ))}
                </>
              )}

              {/* No Orders */}
              {deliveredOrder.length === 0 && (
                <div className="col-12 text-center text-white">
                  <strong>No orders available</strong>
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
};
export default DeliveredOrderHistory;
